export enum FileType {
  Text = "Text",
  Image = "Image",
  Binary = "Binary"
}
